import { render } from "./DailySpendChart.vue?vue&type=template&id=45ad5ffe&scoped=true"
import script from "./DailySpendChart.vue?vue&type=script&lang=js"
export * from "./DailySpendChart.vue?vue&type=script&lang=js"

import "./DailySpendChart.vue?vue&type=style&index=0&id=45ad5ffe&scoped=true&lang=css"

import exportComponent from "/home/walter/projects/finances-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ad5ffe"]])

export default __exports__